import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/showToaster';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';
import { updateStaticBlockSettings } from '../../../lib/graphql';

async function submit(values, dispatch) {
  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  if (!values.blockImage2 || !values.blockImage1) {
    showToaster({ messageId: 'uploadBlockImage', toasterType: 'error' })
    return;
  }
  let variables = Object.assign({}, values, { isEnable: String(values?.isEnable) });

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: updateStaticBlockSettings,
      variables
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateStaticBlockSettings.status === "success") {
    showToaster({ messageId: 'updateStaticBlock', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateStaticError', toasterType: 'error' })
  }

}

export default submit;
